<div class="form-group locale-list" [ngClass]="localeListClass">
    <div *ngFor="let continent of continents | localeFilter: search; trackBy: trackByFn">
        <div class="locale-continent" *ngIf="continent.length > 0">
            {{ continent[0].continent }}
        </div>
        <div class="locale-container">
            <div class="locale-wrapper" [ngClass]="{'active' : isSelectedLocale(localeProperty)}" *ngFor="let localeProperty of continent; trackBy: trackByFn">
                <button (click)="selectLocale(localeProperty)" class="btn btn-link">
                    <flag-icon [localeCountry]="localeProperty.country"></flag-icon>
                    <span>{{ localeProperty.countryDisplay }} - {{ localeProperty.languageDisplay }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
